/**
 * Zapamiętany cel powrotu po zalogowaniu — dla przypadków, w których stan routera NIE PRZEŻYWA
 * drogi na ekran logowania.
 *
 * Normalnie wystarcza `location.state.from` z ProtectedRoute (miękka nawigacja). Ale sesja bywa
 * wygasła: interceptor apiService robi wtedy TWARDE przeładowanie na /logowanie, a to kasuje stan
 * routera. Tą właśnie drogą idzie osoba, która zeskanowała KOD QR PRZEPUSTKI po dłuższej przerwie —
 * i bez tego bufora lądowała po zalogowaniu na pulpicie zamiast na wyniku weryfikacji.
 *
 * sessionStorage (nie localStorage): cel jest ważny wyłącznie w tej karcie i tylko do najbliższego
 * logowania — zapamiętany na stałe wracałby po tygodniu na cudzy skan.
 */
const RETURN_TO_KEY = "bp_return_to";

/** Zapamiętuje ścieżkę wewnętrzną (z query i hashem), na którą trzeba wrócić po zalogowaniu. */
export const rememberReturnPath = (path) => {
    try {
        if (typeof path === "string" && path.startsWith("/") && !path.startsWith("//")) {
            sessionStorage.setItem(RETURN_TO_KEY, path);
        }
    } catch {
        /* prywatny tryb przeglądarki — powrót na pulpit jest akceptowalnym gorszym scenariuszem */
    }
};

/**
 * Odczytuje i JEDNOCZEŚNIE kasuje zapamiętany cel — jednorazowy z założenia, żeby kolejne
 * logowanie nie odsyłało na przepustkę sprzed godziny.
 * Zwraca wyłącznie ścieżkę względną („/…", ale nie „//host") — adres bezwzględny z tego bufora
 * byłby otwartym przekierowaniem na obcy serwer.
 */
export const takeReturnPath = () => {
    try {
        const value = sessionStorage.getItem(RETURN_TO_KEY);
        sessionStorage.removeItem(RETURN_TO_KEY);
        return value && value.startsWith("/") && !value.startsWith("//") ? value : null;
    } catch {
        return null;
    }
};
